import React from 'react'
import { Outlet } from 'react-router-dom'

export const EcuBase: React.FC = () => {
  return <Outlet />
}
